















































































import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import { Component } from '@niknevis/vue-modules'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import CampaignItemPaymentMethods from '@/modules/campaign-item-payment/components/admin/CampaignItemPaymentMethods.vue'
import AvatarUploader from '@/modules/shared/components/shared/form/AvatarUploader.vue'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'
import AdminDepartmentSearch from '@/modules/department/components/admin/AdminDepartmentSearch.vue'
import TicketStatusView from '@/modules/ticket/components/shared/TicketStatusView.vue'
import { Prop } from 'vue-property-decorator'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import { VipGroupResourceModel } from '@/modules/vip-group/models/vip-group-resource.model'
import { AdminVipGroupService } from '@/modules/vip-group/services/admin-vip-group.service'

@Component({
  components: {
    BaseSelect,
    TicketStatusView,
    AdminDepartmentSearch,
    AdminUserSearch,
    CampaignItemPaymentMethods,
    Modal,
    BaseButton,
    BaseInput,
    Toggle,
    AvatarUploader
  }
})
export default class AdminVipGroupCreateForm extends mixins<DialogMixin>(DialogMixin) {
  constructor(
    private readonly vipGroupService: AdminVipGroupService
  ) {
    super()
  }

  @Prop() vipGroup!: VipGroupResourceModel
  @Prop() isLoading!: boolean
  private isNew: boolean = false

  mounted() {
    this.isNew = !!!this.vipGroup.title
  }

  protected setProperty(key, value) {
    this.$set(this.vipGroup, key, value)
  }

  onSubmit() {
    this.$emit('submit', this.vipGroup)
  }

  onDelete() {
    this.vipGroupService.destroy(this.vipGroup.id)
  }
}
